import React from "react";
import { networkTypeConfig } from "@/config/networkType";

interface NetworkTypeBadgeProps {
	type: Dryp.NetworkType;
	showLabel?: boolean;
	showIndicator?: boolean;
	className?: string;
	size?: number;
}

export const NetworkTypeBadge: React.FC<NetworkTypeBadgeProps> = ({
	type,
	showLabel = false,
	showIndicator = true,
	className = "",
	size = 18,
}) => {
	const config = networkTypeConfig[type];
	if (!config) return null;

	return (
		<div className={`flex items-center gap-2 ${className}`}>
			{showIndicator && (
				<span
					className="inline-flex items-center justify-center rounded-full"
					style={{
						backgroundColor: config.bgColor,
						color: config.textColor,
						width: size,
						height: size,
					}}
				></span>
			)}
			{showLabel && <span>{config.label}</span>}
		</div>
	);
};
